module.exports = __webpack_public_path__ + "static/ranger-cutout-c445b8d049eeff09e7c1967b8ebe7496.png";